export default {
    NOME: 1,
    NOME_SOCIAL: 2,
}